import type { VFC } from 'react';
import { Button, Tooltip } from 'antd';
import { Icon } from '@/components/icon';

export interface ActionTableButtonProps {
  onEdit: () => void;
}

export const ActionTableButton: VFC<ActionTableButtonProps> = ({ onEdit }) => (
  <Tooltip title="Edit trial credits">
    <Button icon={<Icon iconString="edit" />} type="text" onClick={onEdit} />
  </Tooltip>
);
